import type { Area } from './sesion.service';

/**
 * Las secciones de la sidebar tal como se muestran al armar los roles. Los permisos reales de
 * la base siguen siendo por area (`sec.role_permissions`): esto solo dice que areas mueve cada
 * seccion, para que la pantalla de roles use los mismos nombres que el menu.
 */
export interface SeccionDePermiso {
  id: string;
  etiqueta: string;
  /** Areas de la base que se fijan juntas. La primera es la que se muestra. */
  areas: readonly Area[];
  /** Sin area propia: se deduce de estas y no se edita (Informes lee de otras secciones). */
  derivadaDe?: readonly Area[];
}

export const SECCIONES_DE_PERMISO: readonly SeccionDePermiso[] = [
  { id: 'personas', etiqueta: 'Personas', areas: ['MAESTROS'] },
  { id: 'acopio', etiqueta: 'Romaneos y boletos', areas: ['ACOPIO'] },
  { id: 'comprobantes', etiqueta: 'Comprobantes', areas: ['DOCUMENTOS'] },
  // Liquidar empleados (ADMIN) es una pestaña de esta seccion: el permiso viaja con ella.
  { id: 'cobros-pagos', etiqueta: 'Cobros y pagos', areas: ['CUENTAS', 'ADMIN'] },
  { id: 'transporte', etiqueta: 'Transporte', areas: ['TRANSPORTE'] },
  { id: 'stock', etiqueta: 'Productos y stock', areas: ['STOCK'] },
  { id: 'informes', etiqueta: 'Informes', areas: [], derivadaDe: ['CUENTAS', 'DOCUMENTOS'] },
  { id: 'configuracion', etiqueta: 'Configuración', areas: ['SEGURIDAD'] },
];

/** Nombre de la seccion para el menu: una sola fuente, asi sidebar y roles dicen lo mismo. */
export function etiquetaDeSeccion(id: string): string {
  const seccion = SECCIONES_DE_PERMISO.find((candidata) => candidata.id === id);
  if (!seccion) throw new Error(`Seccion de permiso inexistente: ${id}`);
  return seccion.etiqueta;
}
